import * as React from 'react';
import {
    Box,
    Grid,
    Button,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    Typography
} from '@mui/material';
import { styled } from '@mui/system';
import Modal from '@mui/material/Modal';
import LinkIcon from '@assets/images/link.svg';
import {IGate} from "@interfaces/token";
import {GATE_TYPES} from "@shared/constants/app.constant";


const ModalContainer = styled('div')(({ theme }) => ({

    [theme.breakpoints.up("sm")]: {
        width: 300,
    },
    [theme.breakpoints.down("md")]: {
        width: '70%'
    },

    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    backgroundColor: 'white',
    boxShadow: '24',
    borderRadius: '10px',
    display: "flex",
    alignItems: "center",
    flexDirection: "column",
    justifyContent: "center",
    padding: '70px 55px 67px 55px'
}));

// export default function GatingDialog({ open, onClose, tableValue, redirectValue }: { open: boolean, onClose: Function, tableValue?: string, redirectValue?: string }) {
export default function GatingDialog({ open, onClose, gates }: { open: boolean, onClose: Function, gates?: Array<IGate> | undefined }) {
    let gateValue:string | undefined = '';
    let gateType = '';
    if(gates){
        for(let gate of gates ) {
            // TODO: fix this
            // For now, emphasize OpenTable, i.e. if OpenTable is set, use that. If not, fall back to other Gate Types
            if(gate.gate_configuration?.type === GATE_TYPES.OPENTABLE ) {
                gateType = GATE_TYPES.OPENTABLE;
                gateValue = gate.values;
                break;
            } else {
                gateType = (gate.gate_configuration?.type) ? gate.gate_configuration?.type : '';
                gateValue = gate.values;
            }
        }
    }



    // COLIN : GET THE VALUES FROM GATE AND ASSIGN THEM TO THE PROPER VARIABLES

    return (
        <Modal
            open={open}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
        >
            <>
                <ModalContainer>
                    {/*<Box>
            <img src={LinkIcon} alt="Reservation Icon" />
          </Box>*/}
                    <DialogTitle id="alert-dialog-title">{"Reservation"}</DialogTitle>
                    <DialogContent>
                       
                        {/* Open Table */}
                        {gateType === GATE_TYPES.OPENTABLE ?
                        <iframe
                            src={gateValue}
                            width="224" height="301" frameBorder="0" scrolling="no"
                            name="opentable-make-reservation-widget"
                            title="Online Reservations"></iframe>
                            : '' }
                        {gateType === GATE_TYPES.REDIRECT ?
                           <a href={gateValue} target="_blank" className={'w-100 text-center d-block'}>{gateValue}</a>
                        : ''}
                    </DialogContent>
                    <Grid container>    
                        <Grid item xs={12} md={12}>
                            <Box>
                                <Button variant="outlined" className={'button w-100'} color="primary"
                                    onClick={() => onClose()} autoFocus>
                                    <Typography fontWeight={700} className={'button-label'}>
                                        Cancel
                                    </Typography>
                                </Button>
                            </Box>
                        </Grid>
                    </Grid>


                </ModalContainer>
            </>
        </Modal>
    );
}
